import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComplianceExemptionService } from '../../services/compliance-exemption.service';
import { ComplianceExemption } from '../../models/user.model';
import { toLocalDateOnly } from '../../utils/compliance-exemption.util';

/** "Free trial until …" strip for buyer/supplier users whose company is exempt. Admins never get one (no /me fetch for them). */
@Component({
  selector: 'app-trial-strip',
  templateUrl: './trial-strip.component.html',
  styleUrls: ['./trial-strip.component.css'],
})
export class TrialStripComponent implements OnInit, OnDestroy {
  ex: ComplianceExemption | null = null;
  private sub?: Subscription;
  constructor(private exemption: ComplianceExemptionService) {}
  ngOnInit(): void { this.sub = this.exemption.mine$.subscribe((e) => (this.ex = e)); }
  ngOnDestroy(): void { this.sub?.unsubscribe(); }
  get visible(): boolean { return !!this.ex && (this.ex.skipTerms || this.ex.skipKyc); }
  get endsAtDate(): Date | null { return toLocalDateOnly(this.ex?.endsAt ?? null); }
}
